export default __webpack_public_path__ + "static/media/arshola-observation.0a34bad5.jpg";